import { render, staticRenderFns } from "./InputVector3.vue?vue&type=template&id=5152722d&"
import script from "./InputVector3.vue?vue&type=script&lang=ts&"
export * from "./InputVector3.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports